import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import es from 'date-fns/locale/es';
import nl from 'date-fns/locale/nl';
import no from 'date-fns/locale/nb';
import pt from 'date-fns/locale/pt';
import sv from 'date-fns/locale/sv';
import zhCN from 'date-fns/locale/zh-CN';
import zhTW from 'date-fns/locale/zh-TW';
import ko from 'date-fns/locale/ko';
import jaJP from 'date-fns/locale/ja';
import da from 'date-fns/locale/da';
import fi from 'date-fns/locale/fi';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import pl from 'date-fns/locale/pl';
import ro from 'date-fns/locale/ro';
import th from 'date-fns/locale/th';
import ru from 'date-fns/locale/ru';
import useUserLocale from 'hooks/useUserLocale';
import { useFormFieldContext } from 'components/FormField';
import { textInputProps, textInputStyle } from 'components/TextInput';
import Box from 'components/Box';
import StyleWrapper from './StyleWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
setDefaultLocale('en-GB');
registerLocale('en-GB', enGB);
registerLocale('en-US', enUS);
registerLocale('de-DE', de);
registerLocale('de-DE-Sie', de);
registerLocale('fr-FR', fr);
registerLocale('es-ES', es);
registerLocale('nl-NL', nl);
registerLocale('no-NO', no);
registerLocale('pt-PT', pt);
registerLocale('sv-SE', sv);
registerLocale('zh-CN', zhCN);
registerLocale('zh-TW', zhTW);
registerLocale('ja-JP', jaJP);
registerLocale('ko-KR', ko);
registerLocale('da-DK', da);
registerLocale('fi-FI', fi);
registerLocale('hu-HU', hu);
registerLocale('it-IT', it);
registerLocale('pl-PL', pl);
registerLocale('ro-RO', ro);
registerLocale('th-TH', th);
registerLocale('ru-RU', ru);
var StyledDatePicker = styled(ReactDatePicker).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !textInputProps.includes(prop);
  }
}).withConfig({
  displayName: "DatePicker__StyledDatePicker",
  componentId: "sc-ire5tk-0"
})(["", ""], textInputStyle);
function DatePicker(props) {
  var _useUserLocale = useUserLocale(),
    locale = _useUserLocale.locale;
  var _useFormFieldContext = useFormFieldContext({
      id: props.id,
      required: props.required,
      descriptionIds: props['aria-describedby']
    }),
    id = _useFormFieldContext.id,
    required = _useFormFieldContext.required,
    descriptionIds = _useFormFieldContext.descriptionIds;
  return /*#__PURE__*/_jsx(StyleWrapper, {
    children: /*#__PURE__*/_jsx(Box, {
      width: props.width || 125,
      children: /*#__PURE__*/_jsx(StyledDatePicker, _objectSpread(_objectSpread({}, props), {}, {
        id: id,
        required: required,
        "aria-describedby": descriptionIds,
        locale: locale
      }))
    })
  });
}
export default DatePicker;